export const subsidyTracking = {
  // Default documents for "In Progress"
  'subsidyTracking.document.businessPlan': 'Business plan',
  'subsidyTracking.document.financialStatements': 'Financial statements (last 3 years)',
  'subsidyTracking.document.registrationDocuments': 'Registration documents / KBIS',
  'subsidyTracking.document.projectDescription': 'Detailed project description',
  'subsidyTracking.document.budgetForecasts': 'Budget forecasts',
  
  // Placeholders  
  'subsidyTracking.placeholder.addDocument': 'Add a document...',
  'subsidyTracking.placeholder.notes': 'Additional notes and details...',
} as const;
